<template>
  <div>
    <px-view-header title="Painel de notificações"
                    title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <px-painel-notificacao-tabs/>
  </div>
</template>
<script>
import PainelNotificacaoTabs from './tabs/PainelNotificacaoTabs.vue';

export default {
  data() {
    return {
      loading: false,
      breadcrumbs: [
        { text: 'Configurações' },
        { text: 'Painel de notificações' },
      ],
    };
  },
  components: {
    pxPainelNotificacaoTabs: PainelNotificacaoTabs,
  },
};
</script>
